import type { Product } from '@/types'

export const products: Product[] = [
  {
    id: 'wearable-module',
    name: 'Wearable Module',
    price: 199,
    type: 'one-time',
    category: 'hardware',
    description: 'The core multi-sensor device. Requires no restrictive chest straps.',
    features: ['Fall Detection', 'Continuous Vitals'],
    step: 'Step 1: Hardware',
  },
  {
    id: 'indoor-hub',
    name: 'Indoor Hub',
    price: 89,
    type: 'one-time',
    category: 'hardware',
    description: 'Facility gateway that uses BLE for precise indoor routing.',
    features: ['Room-level Tracking', 'Secure BLE Mesh'],
    step: 'Step 1: Hardware',
  },
  {
    id: 'monitoring-portal',
    name: 'Monitoring Portal',
    price: 29,
    type: 'recurring',
    category: 'software',
    description: 'Access the Caregiver & Clinician Dashboard for real-time insights.',
    features: ['Live Vitals Dashboard', 'Automated Adina Charting', 'Instant SMS Alerts'],
    step: 'Step 2: Software',
  },
]
